import apiClient from './client';
import type { Articulo, Familia, PaginatedResponse } from '@/types';

export const articulosService = {
  async getArticulos(params: {
    search?: string;
    familiaId?: number;
    page?: number;
    limit?: number;
    clienteId?: number;
    empresa?: number;
  }): Promise<PaginatedResponse<Articulo>> {
    const { data } = await apiClient.get<PaginatedResponse<Articulo>>('/articulos', { params });
    return data;
  },

  async getArticuloById(id: number): Promise<Articulo> {
    const { data } = await apiClient.get<Articulo>(`/articulos/${id}`);
    return data;
  },

  async getFamilias(): Promise<Familia[]> {
    const { data } = await apiClient.get<Familia[]>('/familias');
    return data;
  },

  async getHistorialCliente(
    clienteId: number,
    anios: number = 2,
    empresa?: number
  ): Promise<Array<{
    articuloId: number;
    codigo: string;
    nombre: string;
    imagen: string;
    ultimaCompra: string;
    vecesComprado: number;
    precioUltimaCompra: number;
  }>> {
    const { data } = await apiClient.get(`/articulos/cliente/${clienteId}/historial`, {
      params: empresa ? { anios, empresa } : { anios },
    });
    return data;
  },
};
